import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { Clock, FileText, Users, AlertTriangle } from "lucide-react";
const HerausforderungenVersicherungSection = () => <IndustryChallengesI18n translationPrefix="industryVersicherung" icons={[Clock, FileText, Users, AlertTriangle]} />;
export default HerausforderungenVersicherungSection;
